import * as React from "react";
import { forwardRef, memo } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgOutlinedCalendarBlockIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "1rem",
	height: "1rem",
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M19.25 11.75H4.75V19L4.75586 19.124C4.78436 19.41 4.9112 19.6788 5.11621 19.8838C5.35063 20.1182 5.66848 20.25 6 20.25H18C18.3315 20.25 18.6494 20.1182 18.8838 19.8838C19.1182 19.6494 19.25 19.3315 19.25 19V11.75ZM10 14.25C10.4142 14.25 10.75 14.5858 10.75 15V17C10.75 17.4142 10.4142 17.75 10 17.75H8C7.58579 17.75 7.25 17.4142 7.25 17V15C7.25 14.5858 7.58579 14.25 8 14.25H10ZM8.75 16.25H9.25V15.75H8.75V16.25ZM15.25 7V5.75H8.75V7C8.75 7.41421 8.41421 7.75 8 7.75C7.58579 7.75 7.25 7.41421 7.25 7V5.75H6C5.66848 5.75 5.35063 5.88179 5.11621 6.11621C4.88179 6.35063 4.75 6.66848 4.75 7V10.25H19.25V7C19.25 6.66848 19.1182 6.35063 18.8838 6.11621C18.6788 5.9112 18.41 5.78436 18.124 5.75586L18 5.75H16.75V7C16.75 7.41421 16.4142 7.75 16 7.75C15.5858 7.75 15.25 7.41421 15.25 7ZM20.75 19C20.75 19.7293 20.4601 20.4286 19.9443 20.9443C19.4286 21.4601 18.7293 21.75 18 21.75H6C5.27065 21.75 4.57139 21.4601 4.05566 20.9443C3.53994 20.4286 3.25 19.7293 3.25 19V7C3.25 6.27065 3.53994 5.57139 4.05566 5.05566C4.57139 4.53994 5.27065 4.25 6 4.25H7.25V3C7.25 2.58579 7.58579 2.25 8 2.25C8.41421 2.25 8.75 2.58579 8.75 3V4.25H15.25V3C15.25 2.58579 15.5858 2.25 16 2.25C16.4142 2.25 16.75 2.58579 16.75 3V4.25H18C18.7293 4.25 19.4286 4.53994 19.9443 5.05566C20.4601 5.57139 20.75 6.27065 20.75 7V19Z",
		fill: "#30515B"
	})]
});
const ForwardRef = forwardRef(SvgOutlinedCalendarBlockIcon);
const Memo = memo(ForwardRef);
export default Memo;
